
<template>
    <div v-bind:class="[ boxclass ]">
        <h2>Do I need a Visa?</h2>
        <a href="/#/needvisa">Open the Countries' List</a>
        <div v-if="checked">
            <div v-if="required">
                <span class="header">Visa not required</span>
                <span class="country">{{capitalizedCountry}}</span>
                <button v-on:click="reset()">Check again</button>
            </div>
            <div v-else>
                <span class="header">Visa required</span>
                <span class="country">{{capitalizedCountry}}</span>
                <button v-on:click="reset()">Check again</button>
            </div>
            
        </div>
        <div v-else>
            <input type="text" v-model="country"
                    class="country-blue"
                     autocomplete="off"
                     onfocus="this.placeholder = ''"
                     onblur="this.placeholder = 'Country name'"
                     name="Country"
                     placeholder="Country name" />
            <span class="error-span">{{error}}</span>
            <button class="check-btn" v-on:click="checkCountry()">Check</button>
        </div>
        
    </div>
</template>
<script>
    export default {
        name: 'CheckCountry',

        data: () => ({
            country: '',
            result: {},
            boxclass: 'visa-square',
            required: false,
            checked: false,
            error:''
        }),
        computed: {
            capitalizedCountry: function () {
                var lowerCase = this.country.toLowerCase();
                return lowerCase[0].toUpperCase() + lowerCase.substring(1);
            }
        },
        methods: {
            async checkCountry() {
                try {
                    if (this.country.length > 2) {
                        this.error = ''
                        const response = await fetch(this.$apiip + '/api/v1/application/' + this.country + '/checkcountry')
                        const data = await response.json()
                        this.result = data

                        if (this.result.Status == 1) {
                            this.error = 'Country does not exist';
                        } else {
                            this.checked = true
                            if (this.result.Status == 0) {
                                this.boxclass = 'visa-square checked required'
                            } else {
                                this.required = true
                                this.boxclass = 'visa-square checked'
                            }
                        }
                    } else {
                        this.error = 'Country length must be 3 letters at least';
                    }

                } catch (error) {
                    //console.error(error)
                }
            },
            reset() {
                this.boxclass = 'visa-square'
                this.required = false
                this.checked = false
            }
        }
    }
</script>
